// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize, borderRadius } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'

const Container = styled.div`
  display: inline-block;
  position: relative;
  width: ${props => (props.widthSp ? props.widthSp : '100%')};
  border: 1px solid;
  border-radius: ${borderRadius}px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
      border-color: ${color};
    `}
  ${mediaMin.phone`
    width: ${props => (props.widthPc ? props.widthPc : '100%')};
  `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
      border-color: ${color};
    `}
`
const Badge = styled.div`
  position: absolute;
  top: -7px;
  left: -7px;
  width: 14px;
  height: 14px;
  color: ${Colors.white};
  font-weight: bold;
  background-color: ${Colors.green};
  border-radius: 7px;
`
const ServiceTitle = styled.span`
  display: block;
  width: 100%;
  height: 13px;
  line-height: 13px;
  text-align: center;
  font-weight: bold;
  font-size: 9px;
  color: ${Colors.white};
  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `} ${({ large }) =>
    large &&
    css`
      height: 21px;
      line-height: 21px;
      font-size: ${fontSize.small}px;
    `};
`
const StatusText = styled.span`
  display: block;
  width: 100%;
  height: 24px;
  line-height: 22px;
  text-align: center;
  font-weight: bold;
  font-size: ${fontSize.small}px;
  color: ${Colors.white};
  background-color: ${Colors.white};
  border-radius: ${borderRadius}px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `} ${({ large }) =>
    large &&
    css`
      height: 34px;
      line-height: 34px;
      font-size: ${fontSize.small_3}px;
    `};
`

type PropTypes = {
  phaseText: string,
  isTypeStay?: boolean,
  isActiveReservation?: boolean,
  badge?: boolean,
  large?: boolean,
  widthPc?: string,
  widthSp?: string,
}

export default (props: PropTypes) => {
  let color = Colors.grayB
  if (props.isActiveReservation) {
    color = props.isTypeStay ? Colors.stayPink : Colors.blue
  }

  return (
    <Container color={color} widthPc={props.widthPc} widthSp={props.widthSp}>
      {props.badge && <Badge />}
      <ServiceTitle color={color} large={props.large}>
        {i18n.t(props.isTypeStay ? 'page.shared.stay' : 'page.shared.rental')}
      </ServiceTitle>
      <StatusText color={color} large={props.large}>
        {props.phaseText}
      </StatusText>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/HeaderStatus/index.jsx